<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title">
        <span class="title-icon"></span>
        <span class="title-details">基本信息</span>
      </div>
      <div slot="content">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :disabled="!isEdit"
          :showBtn="false"
          ref="form"
        />
      </div>
      <folded-panel infoName="指标分拆">
        <div slot="content">
          <!--指标分拆表格-->
          <edit-data-table
            :head="headTask"
            :data.sync="tableData"
            :config="{ trigger: 'click', mode: 'cell',autoClearActive:false }"
            :editable="isEdit"
            :showAdd="false"
            height=""
            :toolBar="{ hidden: true }"
            ref="editTable"
          >
            <!-- <template #toolbar="{$index}">
              <span v-if="!isEdit">无</span>
              <el-button
                v-if="isEdit"
                icon="el-icon-delete"
                type="text"
                size="mini"
                @click="delTask($index)"
              ></el-button>
            </template>-->

            <!-- <template #quarterObj="{row}">
              <span>{{row.quarterObj ? row.quarterObj.name: ''}}</span>
            </template>
            <template #quarterObjEdit="{row}">
              <data-box
                hostUrl="/quarter"
                :props="{label: 'name',value: 'code'}"
                v-model="row.quarterObj"
                :tableColumn="quarterHead"
                :multiple="false"
                @confirm="(val)=>{row.quarter = val.id;row.percent = val.percent}"
              ></data-box>
            </template>-->
          </edit-data-table>
        </div>
      </folded-panel>
      <!-- <folded-panel infoName="商机预测">
        <div slot="content">
          <edit-data-table
            ref="businessForecast"
            :head="editTable.headBusinessForecast"
            :editable="true"
            :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
            :showAdd="editTable.showAdd"
            :data.sync="tableData1"
            height=""
          >
            <template #customerObj="{row}">
              <span>{{row.customerObj ? row.customerObj.name: ''}}</span>
            </template>
            <template #customerObjEdit="{row}">
              <data-box
                hostUrl="/customer"
                :props="{label: 'name',value: 'id'}"
                v-model="row.customerObj"
                :tableColumn="headTypes"
                :multiple="false"
                @confirm="(val)=>{row.customer = val.id}"
              ></data-box>
            </template>
            <template #toolbar="{$index}">
              <el-button icon="el-icon-delete" type="text" size="mini" @click="delBusinessForecast($index)"></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>-->
      <!-- <folded-panel infoName="费用预测">
        <div slot="content">
          <edit-data-table
            ref="costForecast"
            :showNumber="editTable.showNumber"
            :head="editTable.headCostForecast"
            :showAdd="editTable.showAdd"
            :border=true
            :editable="true"
            :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
            :data.sync="tableData2"
            height=""
          >
            <template #budgetProjectObj="{row}">
              <div>{{row.budgetProjectObj ? row.budgetProjectObj.name: ''}}</div>
            </template>
            <template #budgetProjectObjEdit="{row}">
              <data-box
                hostUrl="/bsProjectBudget"
                :props="{label: 'name',value: 'id'}"
                v-model="row.budgetProjectObj"
                :tableColumn="dataBoxHead"
                :multiple="false"
                @confirm="(val)=>{row.budgetProject = val.id}"
              />
            </template>
            <template #toolbar="{$index}">
              <el-button icon="el-icon-delete" type="text" size="mini" @click="delCostForecast($index)"></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>-->
      <div class="button">
        <el-button
          v-if="isEdit && billState !== 5"
          class="btn-cancel"
          :loading="loading"
          @click="save(1)"
        >保存</el-button>
        <el-button v-if="isEdit" class="btn-submit" :loading="loading" @click="submit(2)">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
      <!-- <drag-dialog :show="dialogShow" :title="'审批人选择'" :width="'50%'" @close="close">
        <dynamic-form
          labelWidth="110px"
          :formConfig="dialogForm"
          v-model="form2"
          :showBtn="true"
          :showSaveBtn="false"
          :disabled="false"
          @submit="submitConfirm(2)"
          @cancelForm="dialogShow=false"/> />
      </drag-dialog>-->
      <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'25%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
    </div>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import DataTableMixin from "@/mixins/DataTableMixin";
import CrudMixin from "@/mixins/CrudMixin";
import { tableSataus } from "@/views/bill/mixins/status";
import { getFlowNode } from "@/api/hrApproval"
import {
  addTask,
  findTaskById,
  modifyTask,
  removeTask,
  removeBusinessForecast,
  removeCostForecast,
  getQuarterList
} from "@/api/bill/task";
import { parseTime } from "@/utils";
import { getDocumentCode } from "@/views/utils";
import DragDialog from "@/components/DragDialog";
// import { billApprovalHr } from "@/api/bill/ProjectPlan";
import PersonStep from "@/components/PersonStep";
export default {
  name: "TaskForm",
  components: { FoldedPanel, DragDialog, PersonStep },
  mixins: [DataTableMixin, tableSataus, CrudMixin],
  data() {
    return {
      isEdit: false,
      loading: false,
      id: "",
      billState: 0,
      dialogShow: false, // 提交弹窗
      dialogForm: {
        formItemList: []
      },
      tableData: [],
      tableData1: [],
      tableData2: [],
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "billNumber",
            label: "单据编号",
            disabled: true,
            value: "",
            span: 8
          },
          {
            label: "任务人",
            key: "bsPerson",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码"
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: {},
            multiple: false,
            rules: [
              { required: true, message: "任务人不能为空", trigger: "change" }
            ]
          },
          {
            label: "任务部门",
            key: "taskDept",
            type: "input",
            span: 8,
            disabled: true
          },
          {
            key: "taskYear",
            value: "",
            disabled: false,
            placeholder: "请选择",
            type: "date",
            subtype: "year",
            label: "任务年度",
            span: 8,
            valueFormat: "yyyy",
            rules: [
              { required: true, message: "任务年度不能为空", trigger: "blur" }
            ]
          },
          {
            type: "number",
            key: "taskMoney",
            label: "任务金额",
            value: "",
            placeholder: "请输入标题",
            span: 8,
            rules: [
              { required: true, message: "任务金额不能为空", trigger: "blur" },
              {
                validator(rule, value, callback) {
                  const reg = /^\d+\.?(\d{1,2})?$/;
                  if (reg.test(value)) {
                    callback();
                  } else {
                    callback(new Error("小数点后保留两位"));
                  }
                },
                trigger: "blur"
              }
            ]
          },
          {
            type: "number",
            key: "accumulativeContractMoney",
            label: "累计签约金额",
            value: "",
            placeholder: "请输入标题",
            span: 8,
            disabled: true
          },
          {
            type: "number",
            key: "accumulativeMoneyBack",
            label: "累计回款金额",
            value: "",
            placeholder: "请输入标题",
            span: 8,
            disabled: true
          },
          // {
          //   type: "number",
          //   key: "costBudget",
          //   label: "费用预算",
          //   value: "",
          //   placeholder: "请输入标题",
          //   span: 8
          // },
          // {
          //   type: "number",
          //   key: "budgetUsageValue",
          //   label: "预算使用值",
          //   value: "",
          //   placeholder: "请输入标题",
          //   span: 8,
          //   disabled: true
          // },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入标题",
            span: 18,
            maxlength: 200
          }
        ]
      },
      form: { taskMan: "" },
      // 任务分拆表格设置
      headTask: [
        {
          label: "季度",
          prop: "name",
          editRender: { type: "default" }
        },
        {
          label: "起始时间",
          prop: "startTime",
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "yyyy-MM-dd" }
          }
        },
        {
          label: "结束时间",
          prop: "endTime",
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "yyyy-MM-dd" }
          }
        },
        {
          label: "季度占比",
          prop: "percent",
          editRender: { type: "default" }
        },
        {
          label: "预测金额",
          prop: "forecastMoney",
          editRender: {
            type: "default",
            name: "ElInput",
            props: { disabled: true }
          }
        },
        // {
        //   label: "当期签约金额",
        //   prop: "currentContractMoney",
        //   editRender: { type: "default", name: "ElInput",props: {disabled: true} }
        // },
        // {
        //   label: "当期回款金额",
        //   prop: "currentMoneyBack",
        //   editRender: { type: "default", name: "ElInput",props: {disabled: true} }
        // },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      // 商机预测表格设置
      headBusinessForecast: [
        {
          label: "客户",
          prop: "customerObj",
          editRender: { type: "default" }
        },
        {
          label: "预测项目",
          prop: "forecastProject",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "预测金额",
          prop: "forecastMoney",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "商机发起",
          prop: "businessOpportunitiesLaunch",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "累计完成金额",
          prop: "accumulativeCompleteMoney",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      // 费用预测表格设置
      headCostForecast: [
        {
          label: "起始时间",
          prop: "startTime",
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "yyyy-MM-dd" }
          }
        },
        {
          label: "结束时间",
          prop: "endTime",
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "yyyy-MM-dd" }
          }
        },
        {
          label: "预算项目",
          prop: "budgetProjectObj",
          editRender: { type: "default" }
        },
        {
          label: "预算金额",
          prop: "budgetMoney",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "当期发生金额",
          prop: "currentPeriodHappenMoney",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "累计发生金额",
          prop: "accumulativeHappenMoney",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      dataBoxHead: [
        { label: "编码", prop: "code" },
        { label: "名称", prop: "name", query: { type: "input" } },
        { label: "备注", prop: "remark" }
      ],
      quarterHead: [
        { label: "编码", prop: "code" },
        { label: "名称", prop: "name", query: { type: "input" } },
        { label: "备注", prop: "remark" }
      ],
      validatedRefNames: ["form", "editTable"],
      percentSum: 0,
      form2: {}, // hr审批
      assignData: {}, // hr审批人员信息
      stepShow: false,
      personStepData: []
    };
  },
  watch: {
    "form.bsPerson": {
      handler(val) {
        if (val && val.deptEntity && val.deptEntity.name) {
          this.form.taskDept = val.deptEntity.name;
        }
      },
      deep: true
    },
    "form.taskYear": {
      handler(val) {
        if (val && !this.id) {
          getQuarterList({ cycleDay: val }).then(res => {
            this.tableData = [];
            for (const i of res.data) {
              this.tableData.push({
                name: i.name,
                startTime: i.beginTime,
                endTime: i.endTime,
                percent: i.percent,
                forecastMoney: this.form.taskMoney
                  ? (
                      parseInt(this.form.taskMoney) *
                      parseInt(i.percent) *
                      0.01
                    ).toFixed(2)
                  : 0
              });
            }
          });
        }
      },
      deep: true
    },
    "form.taskMoney": {
      handler(val) {
        this.tableData.forEach(ele => {
          ele.forecastMoney = val
            ? (parseInt(val) * parseInt(ele.percent) * 0.01).toFixed(2)
            : 0;
        });
      },
      deep: true
    },
    tableData: {
      handler(val) {
        // 季度占比更改预测金额也需要更改
        this.tableData.forEach(ele => {
          ele.forecastMoney = this.form.taskMoney
            ? (
                parseInt(this.form.taskMoney) *
                parseInt(ele.percent) *
                0.01
              ).toFixed(2)
            : 0;
        });
      },
      deep: true
    }
  },
  created() {
    this.initData();
  },
  methods: {
    formatter(val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    // 详情
    initData() {
       this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
      this.id = this.$route.params.id;
      this.billState = this.$route.params.billState;
      if (this.id) {
        findTaskById(this.id).then(res => {
          if (res.code === 200) {
            const form = res.data.bizPartnerBudgetTask;
            this.form = form;
            this.tableData = res.data.bizTaskSplittingList;
          }
        });
        this.$set(
          this.formConfig.formItemList[
            this.formConfig.formItemList.findIndex(
              ele => ele.key === "taskYear"
            )
          ],
          "disabled",
          true
        );
      } else {
        this.form.billNumber = getDocumentCode("HHRYC");
      }
    },
    // 组装数据
    getFormData(status, val) {
      if (this.form.bsPerson) {
        this.form.taskMan = this.form.bsPerson.id;
      }
      this.form.billState = status;
      this.form.accumulativeContractMoney = 0; // 累计签约金额
      this.form.accumulativeMoneyBack = 0; // 累计回款金额
      // this.form.budgetUsageValue = 0; // 预算使用值
      this.percentSum = 0; // 季度比例总和
      for (const i of this.tableData) {
        this.form.accumulativeContractMoney += parseInt(i.currentContractMoney);
        this.form.accumulativeMoneyBack += parseInt(i.currentMoneyBack);
        // this.form.budgetUsageValue += parseInt(i.percent);
        // i.forecastMoney = parseInt(this.form.taskMoney) * parseInt(i.percent)
        this.percentSum += parseInt(i.percent);
        if (this.percentSum > 100) {
          return this.$notify({
            title: "季度比例总和不能大于100",
            type: "error",
            duration: 2500
          });
        }
      }
      const obj = {};
      obj.bizPartnerBudgetTask = this.form;
      if (status === 2) {
        // HR审批提交人信息
        obj.from = "Budget_task";
        // obj.assignData = val;
      }
      obj.bizTaskSplittingList = this.tableData;
      return obj;
    },
    // 保存
    save(status) {
      this.loading = true;
      const obj = this.getFormData(status);
      console.log(obj);
      if (!obj.bizPartnerBudgetTask.taskMan) {
        this.loading = false;
        return this.$notify({
          title: "任务人必填！",
          type: "error",
          duration: 2500
        });
      }
      if (!obj.bizPartnerBudgetTask.taskYear) {
        this.loading = false;
        return this.$notify({
          title: "年度必填！",
          type: "error",
          duration: 2500
        });
      }
      if (this.form.id) {
        this.updateTask(obj);
      } else {
        this.addTask(obj);
      }
    },
    close() {
      this.stepShow = false;
    },
    submitConfirm(val) {
      // const obj1 = this.getFormData(2, val[0]);
      // console.log(obj1)
      this.loading = true
      const obj = {};
      val.forEach(item => {
        console.log(item);
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj[item.key] = userList;
      });
      this.form.billState = "2";
      this.form.taskMan = this.form.bsPerson.id;
      const subData = {
        bizPartnerBudgetTask: this.form,
        bizTaskSplittingList: this.tableData,
        from: "Budget_task",
        assignData: JSON.stringify(obj)
      };
      console.log(subData);
      if (this.form.id) {
        this.updateTask(subData);
      } else {
        this.addTask(subData);
      }
    },
    // 提交
    submit(status) {
      this.loading = true;
      this._validateForm(this.validatedRefNames)
        .then(() => {
          getFlowNode({ from: "Budget_task", id: this.form.id }).then(res => {
            // console.log(res);
            // this.dialogForm.formItemList = [];
             this.loading = false;
            this.personStepData = [];
            if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
            }
          });
        })
        .catch(e => {
          this.loading = false;
        });
    },
    addTask(data) {
      this.loading = false;
      // 新增
      addTask(data).then(res => {
        this.loading = false;
        this.$notify({
          title: "保存成功",
          type: "success",
          duration: 2500
        });
        this.$router.go(-1);
      });
    },
    // 修改
    updateTask(data) {
      modifyTask(data).then(res => {
        this.loading = false;
        this.$notify({
          title: "修改成功",
          type: "success",
          duration: 2500
        });
        this.$router.go(-1);
      });
    },
    cancel() {
      this.$router.go(-1);
    },
    delTask(index) {
      if (this.tableData[index].id) {
        removeTask(this.tableData[index].id).then(() => {
          this.tableData.splice(index, 1);
        });
      } else {
        this.tableData.splice(index, 1);
      }
    },
    delBusinessForecast(index) {
      if (this.tableData1[index].id) {
        removeBusinessForecast(this.tableData1[index].id).then(() => {
          this.tableData1.splice(index, 1);
        });
      } else {
        this.tableData1.splice(index, 1);
      }
    },
    delCostForecast(index) {
      if (this.tableData2[index].id) {
        removeCostForecast(this.tableData2[index].id).then(() => {
          this.tableData2.splice(index, 1);
        });
      } else {
        this.tableData2.splice(index, 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .box-card {
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    border-radius: 10px;

    .content-title {
      height: 40px;
      background-color: #e7eff6;
      padding-left: 20px;
      overflow: hidden;

      .title-icon {
        display: inline-block;
        margin-top: 8px;
        width: 4px;
        height: 24px;
        background-color: #1369a8;
        margin-right: 14px;
      }

      .title-details {
        overflow: hidden;
        line-height: 20px;
        display: inline-block;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-family: SourceHanSansSC-regular;
      }
    }

    .button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
  }
}
</style>
